// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "./ActionType";
import { FailureAction } from "./FailureAction";
// Utilities
import { LocalIdGenerator } from "@ms/uno-utilities/lib/local/LocalIdGenerator";
// #region FETCH ENTITY ACTIONS
export class FetchEntityAction extends TypedAction(ActionType.FetchEntityAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId){
        super(), this.entityType = entityType, this.entityId = entityId;
    }
}
export class FetchEntitySucceededAction extends TypedAction(ActionType.FetchEntitySucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"],
            forceOverrideStoredData: String(this.forceOverrideStoredData)
        };
    }
    constructor(entityType, entity, forceOverrideStoredData){
        super(), this.entityType = entityType, this.entity = entity, this.forceOverrideStoredData = forceOverrideStoredData;
    }
}
export class FetchEntityFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId, response, textStatus, errorThrown, errorCode){
        super(ActionType.FetchEntityFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.entityId = entityId;
    }
}
export class FetchEntityCollectionAction extends TypedAction(ActionType.FetchEntityCollectionAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            parentType: this.parentType,
            parentId: this.parentId,
            relationship: this.relationship
        };
    }
    constructor(entityType, parentType, parentId, relationship){
        super(), this.entityType = entityType, this.parentType = parentType, this.parentId = parentId, this.relationship = relationship;
    }
}
export class FetchEntityCollectionSucceededAction extends TypedAction(ActionType.FetchEntityCollectionSucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            parentType: this.parentType,
            parentId: this.parentId,
            relationship: this.relationship,
            isFirstPage: String(this.isFirstPage),
            isLastPage: String(this.nextLink == null),
            hasDeltaLink: String(this.deltaLink != null),
            forceOverrideStoredData: String(this.forceOverrideStoredData)
        };
    }
    constructor(entityType, parentType, parentId, relationship, entities, nextLink, isFirstPage = false, accumulatedEntityIds = null, deltaLink, forceOverrideStoredData){
        super(), this.entityType = entityType, this.parentType = parentType, this.parentId = parentId, this.relationship = relationship, this.entities = entities, this.nextLink = nextLink, this.isFirstPage = isFirstPage, this.accumulatedEntityIds = accumulatedEntityIds, this.deltaLink = deltaLink, this.forceOverrideStoredData = forceOverrideStoredData;
    }
}
export class FetchEntityCollectionFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            parentType: this.parentType,
            parentId: this.parentId,
            relationship: this.relationship
        };
    }
    constructor(entityType, parentType, parentId, relationship, response, textStatus, errorThrown, errorCode){
        super(ActionType.FetchEntityCollectionFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.parentType = parentType, this.parentId = parentId, this.relationship = relationship;
    }
}
// #endregion FETCH ENTITY ACTIONS
// #region CREATE ENTITY ACTIONS
export class CreateEntityAction extends TypedAction(ActionType.CreateEntityAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"]
        };
    }
    constructor(entityType, entity){
        super(), this.entityType = entityType, this.entity = entity;
    }
}
export class CreateEntitySucceededAction extends TypedAction(ActionType.CreateEntitySucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"],
            localId: this.localId
        };
    }
    constructor(entityType, entity, localId){
        super(), this.entityType = entityType, this.entity = entity, this.localId = localId;
    }
}
export class CreateEntityFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            entityId: this.entity["id"]
        };
    }
    constructor(entityType, entity, response, textStatus, errorThrown, errorCode){
        super(ActionType.CreateEntityFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.entity = entity;
    }
}
// #endregion CREATE ENTITY ACTIONS
// #region DELETE ENTITY ACTIONS
export class DeleteEntityAction extends TypedAction(ActionType.DeleteEntityAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId){
        super(), this.entityType = entityType, this.entityId = entityId;
    }
}
export class DeleteEntitySucceededAction extends TypedAction(ActionType.DeleteEntitySucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId){
        super(), this.entityType = entityType, this.entityId = entityId;
    }
}
export class DeleteEntityFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId, response, textStatus, errorThrown, errorCode){
        super(ActionType.DeleteEntityFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.entityId = entityId;
    }
}
// #endregion DELETE ENTITY ACTIONS
// #region UPDATE ENTITY ACTIONS
export class UpdateEntityAction extends TypedAction(ActionType.UpdateEntityAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId, delta, updateKey){
        super(), this.entityType = entityType, this.entityId = entityId, this.delta = delta, this.updateKey = updateKey;
    }
}
export class UpdateEntityFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            entityId: this.entityId,
            updateKey: this.updateKey
        };
    }
    constructor(entityType, entityId, updateKey, response, textStatus, errorThrown, errorCode){
        super(ActionType.UpdateEntityFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.entityId = entityId, this.updateKey = updateKey;
    }
}
export class UpdateEntitySucceededAction extends TypedAction(ActionType.UpdateEntitySucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"],
            updateKey: this.updateKey
        };
    }
    constructor(entityType, originalEntity, entity, updateKey){
        super(), this.entityType = entityType, this.originalEntity = originalEntity, this.entity = entity, this.updateKey = updateKey;
    }
}
export class UndoRedoUpdateEntitySucceededAction extends TypedAction(ActionType.UndoRedoUpdateEntitySucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"],
            updateKey: this.updateKey
        };
    }
    constructor(entityType, originalEntity, entity, updateKey){
        super(), this.entityType = entityType, this.originalEntity = originalEntity, this.entity = entity, this.updateKey = updateKey;
    }
}
export class UpdateEntityTrackableAction extends UpdateEntityAction {
    constructor(entityType, entityId, delta, updateKey){
        super(entityType, entityId, delta, updateKey), this.isTrackingEnabled = true;
        this.actionId = LocalIdGenerator.generate();
    }
}
export class UpdateEntityTrackableFailedAction extends UpdateEntityFailedAction {
    constructor(entityType, entityId, updateKey, response, textStatus, errorThrown, errorCode){
        super(entityType, entityId, updateKey, response, textStatus, errorThrown, errorCode), this.isTrackingEnabled = true;
        this.actionId = LocalIdGenerator.generate();
    }
}
export class UpdateEntityTrackableSucceededAction extends UpdateEntitySucceededAction {
    constructor(entityType, originalEntity, updatedEntity, updateKey){
        super(entityType, originalEntity, updatedEntity, updateKey), this.isTrackingEnabled = true;
        this.actionId = LocalIdGenerator.generate();
    }
}
// #endregion UPDATE ENTITY ACTIONS
// #region UNDELETE ENTITY ACTIONS
/** Un-delete an entity whose delete operation is still in flight (undo of an optimistic delete) — restores the entity locally without a server call */ export class UnDeleteEntityAction extends TypedAction(ActionType.UnDeleteEntityAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"]
        };
    }
    constructor(entityType, entity){
        super(), this.entityType = entityType, this.entity = entity;
    }
}
export class UnDeleteEntitySucceededAction extends TypedAction(ActionType.UnDeleteEntitySucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"]
        };
    }
    constructor(entityType, entity){
        super(), this.entityType = entityType, this.entity = entity;
    }
}
export class UnDeleteEntityFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId, response, textStatus, errorThrown, errorCode){
        super(ActionType.UnDeleteEntityFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.entityId = entityId;
    }
}
// #endregion UNDELETE ENTITY ACTIONS
// #region DELTA SYNC ACTIONS
export class DeltaSyncAction extends TypedAction(ActionType.DeltaSyncAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            parentType: this.parentType,
            parentId: this.parentId,
            relationship: this.relationship
        };
    }
    constructor(entityType, parentType, parentId, relationship){
        super(), this.entityType = entityType, this.parentType = parentType, this.parentId = parentId, this.relationship = relationship;
    }
}
export class DeltaSyncSucceededAction extends TypedAction(ActionType.DeltaSyncSucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            parentType: this.parentType,
            parentId: this.parentId,
            relationship: this.relationship
        };
    }
    constructor(entityType, parentType, parentId, relationship, deltas, deltaLink, nextLink){
        super(), this.entityType = entityType, this.parentType = parentType, this.parentId = parentId, this.relationship = relationship, this.deltas = deltas, this.deltaLink = deltaLink, this.nextLink = nextLink;
    }
}
export class DeltaSyncFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            parentType: this.parentType,
            parentId: this.parentId,
            relationship: this.relationship
        };
    }
    constructor(entityType, parentType, parentId, relationship, response, textStatus, errorThrown, errorCode){
        super(ActionType.DeltaSyncFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.parentType = parentType, this.parentId = parentId, this.relationship = relationship;
    }
}
// #endregion DELTA SYNC ACTIONS
// #region UNDO DELTA ACTIONS
export class SuspendEntityDeltaAction extends TypedAction(ActionType.SuspendEntityDeltaAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId,
            deltaKey: this.deltaKey
        };
    }
    constructor(entityType, entityId, deltaKey){
        super(), this.entityType = entityType, this.entityId = entityId, this.deltaKey = deltaKey;
    }
}
export class ResumeEntityDeltaAction extends TypedAction(ActionType.ResumeEntityDeltaAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId,
            deltaKey: this.deltaKey
        };
    }
    constructor(entityType, entityId, deltaKey){
        super(), this.entityType = entityType, this.entityId = entityId, this.deltaKey = deltaKey;
    }
}
export class DropSuspendedDeltaAction extends TypedAction(ActionType.DropSuspendedDeltaAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId,
            deltaKey: this.deltaKey
        };
    }
    constructor(entityType, entityId, deltaKey){
        super(), this.entityType = entityType, this.entityId = entityId, this.deltaKey = deltaKey;
    }
}
// #endregion UNDO DELTA ACTIONS
// #region BASELINE CHAIN ACTIONS
/** Prune a single baseline-chain entry (identified by deltaKey) from an entity — used to remove an invalidated undo/redo snapshot */ export class PruneBaselineChainAction extends TypedAction(ActionType.PruneBaselineChainAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId,
            deltaKey: this.deltaKey,
            prunePrefix: String(this.prunePrefix)
        };
    }
    constructor(entityType, entityId, deltaKey, prunePrefix = false){
        super(), this.entityType = entityType, this.entityId = entityId, this.deltaKey = deltaKey, this.prunePrefix = prunePrefix;
    }
} // #endregion BASELINE CHAIN ACTIONS
